<template>
  <!-- 团队文件 -->
  <el-card shadow="never" class="join_card">
    <div slot="header" class="clearfix">
      <div class="desciconLarge"></div>
      <span class="font18">团队文件</span>
    </div>
    <div class="space">
      <div class="spaceLeft">
        <div class="spacetitle">
          <el-input
            v-model="queryParams.spaceName"
            placeholder="空间名称"
            style="width: 100%"
            size="small"
            @keyup.enter.native="handleChangeName(queryParams)"
            @blur="handleChangeName(queryParams)"
          >
            <i
              slot="suffix"
              style="cursor:pointer"
              @click="handleChangeName(queryParams)"
              class="el-input__icon el-icon-search"
            ></i>
          </el-input>
        </div>

        <div
          v-for="(item, index) in spaceList"
          :key="item.index"
          :class="{ isActive:isChange === index}"
          @click="tabBtn(item,index)"
        >
          <div style="cursor:pointer;">
            <div class="spacetitle">
              <svg-icon :icon-class="'filekj'" class-name="disabled" />
              {{item.spaceName}}
            </div>
            <div class="spacetitle1">
              <div class="padingtop5">创建时间:{{item.spaceCreateTime}}</div>
              <div class="padingtop5">文件数量：{{item.spaceFileNumber}}</div>
              <div class="padingtop5">
                <el-progress
                  v-if="item.spaceType != 5"
                  :width="90"
                  :height="90"
                  :show-text="false"
                  :percentage="item.spaceUsedSize != '0' && item.spaceSize !='0' ?Math.ceil(Number(item.spaceUsedSize)/item.spaceSize): 0"
                  :stroke-width="10"
                ></el-progress>
              </div>
              <div class="padingtop5">{{item.spaceUsedSizeStr}}/{{item.spaceSizeStr}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="fileList" style="margin-top: 9px">
        <searchForm
          ref="form"
          :searchData="queryParams"
          :searchForm="searchForm"
          :searchHandle="searchHandle"
        ></searchForm>
        <div style="float: right;margin-bottom: 10px">
          <el-button @click="handleDownloads()" size="small">批量下载</el-button>
        </div>
        <el-table
          :height="`calc(100vh - 110px)`"
          border
          ref="singleTable"
          :header-cell-style="{background:'#F5F5F5'}"
          :data="fileList"
          @selection-change="handleSelectionChange"
          row-key="sfFileId"
          header-align="center"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column type="selection" width="50" align="center" />
          <el-table-column prop="sfFileName" label="名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <svg-icon v-if="scope.row.sfFileType == 'd'" icon-class="files" />
              <span v-else>
                <svg-icon
                  v-if="scope.row.sfFileExpandName == 'jpeg' || scope.row.sfFileExpandName == 'png' || scope.row.sfFileExpandName == 'jpg'"
                  icon-class="pic"
                />
                <svg-icon v-else icon-class="fileText" />
              </span>
              {{scope.row.sfFileName}}
            </template>
          </el-table-column>
          <el-table-column prop="sfFileSizeStr" align="center" label="大小"></el-table-column>
          <el-table-column prop="sfFileModifyTime" align="center" label="上传时间"></el-table-column>
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.sfFileType == 'f'"
                size="mini"
                type="text"
                @click="handleDownload(scope.row)"
              >下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-card>
</template>

<script>
import searchForm from "@/components/searchItem";
import { spaceTeamList, myFileList } from "@/api/request";
import { getClient } from "@/plugins/auth";

export default {
  components: {
    searchForm
  },
  data() {
    return {
      userInfo: JSON.parse(getClient()),
      fileList: [],
      percentage: 0,
      total: 0,
      isChange: 0,
      selectionList: [],
      ids: [],
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        sfFileName: undefined,
        startTime: undefined,
        endTime: undefined,
        spaceType: null,
        timerange: []
      },
      spaceList: [],
      searchHandle: [
        { label: "查询", type: "primary", handle: this.getspaceFileList }
      ],
      searchForm: [
        {
          type: "Input",
          prop: "sfFileName",
          placeholder: "文件名称"
        },
        {
          type: "daterange",
          prop: "timerange",
          width: "150px",
          startPlaceholder: "上传开始时间",
          endPlaceholder: "上传结束时间"
        }
      ]
    };
  },
  mounted() {
    if (this.userInfo.commanderFlag == 1) {
      this.tabSubMenu();
    }
  },
  methods: {
    handleChangeName(val) {
      this.tabSubMenu(val);
    },
    // 点击切换空间
    tabSubMenu() {
      spaceTeamList({
        spaceName: this.queryParams.spaceName,
        teamId: this.userInfo.teamId
      }).then(res => {
        this.fileList = [];
        this.spaceList = res.rows;
        if (res.rows.length > 0) {
          this.getspaceFileList();
        }
      });
    },
    getspaceFileList() {
      let params = {
        sfSpaceId: this.spaceList[this.isChange].spaceId,
        sfFileName: this.queryParams.sfFileName,
        startTime:
          this.queryParams.timerange != null
            ? this.queryParams.timerange[0]
            : undefined,
        endTime:
          this.queryParams.timerange != null
            ? this.queryParams.timerange[1]
            : undefined
      };
      myFileList(params).then(res => {
        this.fileList = this.handleTree(res.rows, "sfFileId", "sfParentFileId");
        this.list = res.rows;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selectionList = selection;
      this.ids = selection.map(item => item.sfFileId);
    },
    // 空间切换
    tabBtn(item, index) {
      this.isChange = index;
      this.getspaceFileList();
    },
    // 单个下载
    handleDownload(row) {
      let url = process.env.VUE_APP_FILE_API;
      var alink = document.createElement("a");
      alink.href = url + row.sfFileUrl;
      alink.download = row.sfFileName;
      alink.click();
    },
    // 批量下载
    handleDownloads() {
      if (this.selectionList.length == 0) {
        return this.$message.error("请选择需要下载的文件");
      }
      let ids = [];
      let fileIds = [...new Set(this.getAllId(ids, this.selectionList))];
      if (fileIds.length != 0) {
        this.$download.getDownLoadXls("/fileSpace/fileShared/exportFileList", {
          fileIds: fileIds.toString()
        });
      } else {
        this.$message.error("所选列表没有可下载的文件");
      }
    },
    // 递归 获取所有children的id
    getAllId(keys, dataList) {
      if (dataList && dataList.length) {
        for (let i = 0; i < dataList.length; i++) {
          if (dataList[i].sfFileType != "d") {
            keys.push(dataList[i].sfFileId);
          }
          if (dataList[i].children) {
            keys = this.getAllId(keys, dataList[i].children);
          }
        }
      }
      return keys;
    }
  }
};
</script>
<style scoped lang="scss">
.space {
  width: 100%;
  // margin-top: 50px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.spaceLeft {
  width: 20%;
  overflow: hidden;
  overflow-y: scroll;
  height: calc(100vh - 200px);
  border-right: 1px solid #ebeef5;
  background: #fff;

  .spacetitle {
    font-size: 15px;
    padding: 10px;
  }
  .spacetitle1 {
    font-size: 12px;
    margin-left: 20px;
    padding: 0px 10px 10px;
  }
  .padingtop5 {
    padding-top: 8px;
  }
  .leftcontent {
    cursor: pointer;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around;
    line-height: 20px;
  }
  .isActive {
    background: rgba(24, 144, 255, 0.1);
  }
}

.fileList {
  width: 77%;
}
</style>